import { getFullUrl } from 'hubspot-url-utils';
import { getApplicationLocale } from '../i18n/LocaleUtils';
export const getBusinessBoxUrl = ({
  portalId,
  hublet,
  route = ''
}) => {
  return `${getFullUrl('app', {
    hubletOverride: hublet
  })}/business-in-a-box/${portalId}/${route}?lang=${getApplicationLocale()}`;
};